module.exports = require('./src/google-maps-api-loader.js');



// WEBPACK FOOTER //
// ./project/client/src/core/vendor/google-maps-api-loader/index.js